import React from 'react'

const AfterServiceDD = () => {
  const afterserobj = [
    {
      id:1,
      name:"Responsive Design",
    },
    {
      id:2,
      name:"React Web Development",
    },
    {
      id:3,
      name:"Android Apps Development",
    },
    {
      id:4,
      name:"Laravel Web Development",
    },
    {
      id:5,
      name:".Net Web Development",
    },
    {
      id:6,
      name:"iOS Apps Development",
    },
    {
      id:7,
      name:"UX/UI Design",
    },
    {
      id:8,
      name:"E-commerce Development",
    },
  ]
  return (
    <div>
      <section className="services-area pt-60 pb-60 serv-aftr-cus">
        <div className="container">
          <div className="row h-100 justify-content-center ">
            <div className="col-lg-6 col-md-12 services-left-image">
              <img
                src="assets/img/services-left-image/design-&-development.webp"
                className="wow fadeInUp"
                loading="lazy"
                data-wow-delay="0.6s"
                alt="main-pic"
                style={{ display: "block" }}
              />
            </div>
            <div className="col-lg-6 col-md-12 services-content">
              <div className="section-title">
                <h2 className='fontkumbh'>SEO Friendly Website design and development</h2>
                <div className="bar" />
                <p className="text-justify">
                  A design can improve with the contribution of a developer, and code
                  can be better written with the assistance of a designer. With the
                  years of experience, we are able to deliver the perfect web design
                  and development solutions to you.
                </p>
              </div>
              <div className="row">
                {afterserobj.map((aftersercard)=>{
                  return <div className="col-lg-6 col-md-6 col-sm-6" key={aftersercard.id}>
                  <div className="box"> <i data-feather="layout" /> {aftersercard.name} </div>
                </div>
                })}
              </div>
            </div>
          </div>
        </div>
      </section>

    </div>
  )
}

export default AfterServiceDD